import styled, { css } from 'styled-components';
import { NoResult } from '../../../../pages/browse/styles';

export const Wrapper = styled.div`
    background-color: ${p => p.theme.c.snow};
    padding: 24px 0;
`;


export const ListAligner = styled.div`
    margin: 0 24px;
    ${p => p.theme.xs(css`
        margin: 0 16px;
    `)}
`;


export const ListHolder = styled.div`
    display: grid;
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    margin-bottom: 16px;
    ${p =>
        p.theme.md.only(css`
            grid-template-columns: 1fr 1fr;
        `)}

    ${p =>
        p.theme.lg(css`
            grid-template-columns: 1fr 1fr 1fr;
        `)}
    ${p =>
        p.theme.sm.max(css`
            grid-template-columns: 1fr 1fr;
        `)}
    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

export const NoResultChoirs = styled(NoResult)`
    margin-top: 20vh;
    margin-bottom: 20vh;
`;
